/* Tend To nudge 3: shop fixes.
   1. Sold-out options are marked, and the button says sold out when one is picked.
   2. A small "Added to your cart" panel appears after adding.
   Delete this file and its line in layout/theme.liquid to undo. */
(function () {
  var money = new Intl.NumberFormat('en-GB', { style: 'currency', currency: window.ttCurrency || 'GBP' });
  var ADD = (window.variantStrings && window.variantStrings.addToCart) || 'Add to cart';

  /* ---------- 1. Variant picker ---------- */
  function setup(root) {
    if (!root || root.dataset.ttReady) return;
    var json = root.querySelector('script[type="application/json"]');
    if (!json) return;
    var variants;
    try { variants = JSON.parse(json.textContent); } catch (e) { return; }
    root.dataset.ttReady = '1';
    root._ttVariants = variants;
    update(root);
  }

  function parts(root) {
    var scope = root.closest('section') || document;
    var r = root.querySelector('input[type="radio"][form]');
    var formId = r ? r.getAttribute('form') : null;
    var form = formId ? document.getElementById(formId) : scope.querySelector('form[data-type="add-to-cart-form"]');
    if (!form) return null;
    return {
      scope: scope,
      form: form,
      hidden: form.querySelector('input[name="id"]'),
      btn: form.querySelector('button[name="add"]'),
      price: scope.querySelector('[data-price-wrapper] .price__regular .price-item'),
      err: scope.querySelector('.product-form__error-message-wrapper')
    };
  }

  function update(root) {
    var variants = root._ttVariants;
    if (!variants) return;
    var p = parts(root);
    if (!p || !p.hidden || !p.btn) return;
    var inQuickAdd = !!root.closest('quick-add-modal');
    var soldWord = (!inQuickAdd && window.ttSoldWord) ? window.ttSoldWord : 'Sold out';
    var fieldsets = Array.prototype.slice.call(root.querySelectorAll('fieldset'));
    var sel = fieldsets.map(function (f) { var c = f.querySelector('input:checked'); return c ? c.value : null; });

    // Mark each option: can it be bought with the other choices as they are?
    fieldsets.forEach(function (f, i) {
      f.querySelectorAll('input[type="radio"]').forEach(function (inp) {
        var test = sel.slice(); test[i] = inp.value;
        var ok = variants.some(function (v) {
          return v.available && v.options.every(function (o, j) { return o === test[j]; });
        });
        var lab = f.querySelector('label[for="' + inp.id + '"]');
        if (lab) {
          lab.classList.toggle('tt-soldout', !ok);
          lab.classList.toggle('is-selected', inp.checked);
          lab.title = ok ? '' : soldWord;
        }
      });
    });

    var v = variants.find(function (v) { return v.options.every(function (o, i) { return o === sel[i]; }); });
    if (p.err) p.err.hidden = true;
    var span = p.btn.querySelector('span') || p.btn;
    if (!v) {
      setBtn(p.btn, span, false, 'Unavailable');
      return;
    }
    p.hidden.value = v.id;
    setBtn(p.btn, span, v.available, v.available ? ADD : soldWord);
    if (p.price) p.price.textContent = money.format(v.price / 100);
    if (!inQuickAdd && root.dataset.updateUrl !== 'false' && window.history && window.history.replaceState) {
      try { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState(null, '', u.toString()); } catch (e) {}
    }
  }

  function setBtn(btn, span, on, text) {
    span.textContent = text;
    btn.dataset.originalText = text;
    btn.disabled = !on;
    btn.classList.toggle('tt-btn-soldout', !on);
    if (on) btn.removeAttribute('aria-disabled'); else btn.setAttribute('aria-disabled', 'true');
  }

  document.addEventListener('change', function (e) {
    var root = e.target.closest && e.target.closest('variant-radios');
    if (!root) return;
    setup(root);
    update(root);
  });

  function setupAll() { document.querySelectorAll('variant-radios').forEach(setup); }
  document.addEventListener('DOMContentLoaded', setupAll);
  if (window.MutationObserver) {
    new MutationObserver(function () { document.querySelectorAll('variant-radios:not([data-tt-ready])').forEach(setup); })
      .observe(document.documentElement, { childList: true, subtree: true });
  }

  /* ---------- 2. "Added" panel ---------- */
  var panel, timer;
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function showAdded(item) {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(item, cart); })
      .catch(function () { render(item, null); });
  }

  function render(item, cart) {
    if (!panel) {
      panel = document.createElement('div');
      panel.className = 'tt-added';
      panel.setAttribute('role', 'dialog');
      panel.setAttribute('aria-label', 'Added to your cart');
      document.body.appendChild(panel);
      panel.addEventListener('mouseenter', function () { clearTimeout(timer); });
      panel.addEventListener('click', function (e) { if (e.target.closest('[data-tt-close]')) hide(); });
      document.addEventListener('keyup', function (e) { if (e.key === 'Escape') hide(); });
    }
    var img = item && (item.featured_image && item.featured_image.url || item.image);
    if (img && img.indexOf('?') === -1) img += '?width=160'; else if (img) img += '&width=160';
    var variant = item && item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
    var count = cart ? cart.item_count : null;
    var total = cart ? money.format(cart.total_price / 100) : '';
    panel.innerHTML =
      '<div class="tt-added__inner">' +
        '<div class="tt-added__top"><p class="tt-added__label">Added to your cart</p>' +
        '<button type="button" class="tt-added__x" data-tt-close aria-label="Close">&times;</button></div>' +
        (item ? '<div class="tt-added__item">' +
          (img ? '<img src="' + esc(img) + '" alt="" width="64" height="80">' : '') +
          '<div><p class="tt-added__title">' + esc(item.product_title || item.title) + '</p>' +
          (variant ? '<p class="tt-added__meta">' + esc(variant) + '</p>' : '') +
          '<p class="tt-added__meta">' + money.format((item.final_line_price || item.price || 0) / 100) + '</p></div></div>' : '') +
        '<div class="tt-added__actions">' +
          '<a class="btn tt-added__checkout" href="/checkout">Check out' + (total ? ' · ' + total : '') + '</a>' +
          '<a class="tt-added__cart" href="/cart">View cart' + (count ? ' (' + count + ')' : '') + '</a>' +
          '<button type="button" class="tt-added__keep" data-tt-close>Keep looking</button>' +
        '</div>' +
      '</div>';
    requestAnimationFrame(function () { panel.classList.add('is-open'); });
    clearTimeout(timer);
    timer = setTimeout(hide, 9000);
  }

  function hide() { if (panel) panel.classList.remove('is-open'); clearTimeout(timer); }

  document.addEventListener('tt:added', function (e) {
    var d = e.detail || {};
    var item = d.items ? d.items[d.items.length - 1] : (d.id ? d : null);
    showAdded(item);
  });
  window.ttShowAdded = showAdded;

  // Spot any successful add to cart (product page, quick add or anywhere else) without touching the theme's own cart code
  if (window.fetch && !window.fetch._tt) {
    var origFetch = window.fetch;
    var wrapped = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
      var p = origFetch.apply(this, arguments);
      if (method === 'POST' && /\/cart\/add(\.js)?(\?|$)/.test(url.replace(window.location.origin, ''))) {
        p.then(function (res) {
          if (!res.ok) return;
          res.clone().json().then(function (data) {
            if (data && !data.status) document.dispatchEvent(new CustomEvent('tt:added', { detail: data }));
          }).catch(function () {});
        }).catch(function () {});
      }
      return p;
    };
    wrapped._tt = true;
    window.fetch = wrapped;
  }
})();
